import React from 'react';

function CreaturesFilters({ filters, filterOptions, onFilterChange }) {
  const handleChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  const handleReset = () => {
    onFilterChange({
      search: '',
      dungeon: '',
      slots: '',
      class: '',
      combat: '',
      minTaming: '',
      maxTaming: ''
    });
  };

  return (
    <div className="creatures-filters">
      <div className="filters-header">
        <h3>Filters</h3>
        <button className="btn-reset" onClick={handleReset}>Reset All</button>
      </div>

      <div className="filter-group">
        <label>Search by Name</label>
        <input
          type="text"
          placeholder="Search creatures..."
          value={filters.search}
          onChange={(e) => handleChange('search', e.target.value)}
        />
      </div>

      <div className="filter-group">
        <label>Dungeon</label>
        <select
          value={filters.dungeon}
          onChange={(e) => handleChange('dungeon', e.target.value)}
        >
          <option value="">All Dungeons</option>
          {filterOptions.dungeons.map(d => (
            <option key={d} value={d}>{d}</option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label>Slots</label>
        <select
          value={filters.slots}
          onChange={(e) => handleChange('slots', e.target.value)}
        >
          <option value="">All Slots</option>
          {filterOptions.slots.map(s => (
            <option key={s} value={s}>{s} Slot{s > 1 ? 's' : ''}</option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label>Class</label>
        <select
          value={filters.class}
          onChange={(e) => handleChange('class', e.target.value)}
        >
          <option value="">All Classes</option>
          {filterOptions.classes.map(c => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label>Combat Type</label>
        <select
          value={filters.combat}
          onChange={(e) => handleChange('combat', e.target.value)}
        >
          <option value="">All Types</option>
          {filterOptions.combatTypes.map(c => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label>Taming Skill Range</label>
        <div className="range-inputs">
          <input
            type="number"
            placeholder="Min"
            min="0"
            max="120"
            value={filters.minTaming}
            onChange={(e) => handleChange('minTaming', e.target.value)}
          />
          <span>to</span>
          <input
            type="number"
            placeholder="Max"
            min="0"
            max="120"
            value={filters.maxTaming}
            onChange={(e) => handleChange('maxTaming', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}

export default CreaturesFilters;
